/**
 * 月度计划新增页面 货品配置处理
 * @author zjs
 * @time 2023-04-24
 */
let vm = {
    isTriggerFunc: true, // 标识是否触发func配置的调用
    data () {
        return {
            productConfig: [{
                prop: 'weidu_id',
                label: '核算纬度',
                component: 'LySelect',
                json: {
                    defOne: false,
                    all: false,
                    api: "api/accountingDimension"
                }
            }, {
                prop: 'yewuxian',
                label: '业务线标识',
                component: 'LySelect',
                json: {
                    defOne: false,
                    all: false,
                    api: "api/yewuxian"
                }
            }, {
                prop: 'caigou_plan',
                label: '采购计划数',
                component: 'LyInputNumber'
            }, {
                prop: 'xiaoshou_plan',
                label: '销售计划数',
                component: 'LyInputNumber'
            },{
                prop: 'storage_plan',
                label: '计划库存数',
                component: 'LyInputNumber'
            }
        ]
        }
    }
}
export default vm